// src/components/Footer.jsx
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#0f172a] text-white mt-12">
      <div className="max-w-7xl mx-auto px-6 py-10 grid md:grid-cols-3 gap-8">
        <div>
          <img src="/images/logo.png" alt="Logo" className="h-12 mb-4" />
          <p className="text-gray-300 text-sm">
            Portal de Ordenamientos Territoriales del Estado de Jalisco.
          </p>
        </div>
        <div>
          <h3 className="font-semibold mb-3">Enlaces</h3>
          <ul className="space-y-2 text-gray-300">
            <li><Link to="/">Inicio</Link></li>
            <li><Link to="/costalegre">Regiones</Link></li>
            <li><Link to="/ordenamiento/estatal">Ordenamiento Territorial</Link></li>
            {/* <li><Link to="/contacto">Contacto</Link></li> */}
          </ul>
        </div>
        <div>
          <h3 className="font-semibold mb-3">Contacto</h3>
          <p className="text-gray-300 text-sm">Tel: (33) 3030 8250</p>
          <p className="text-gray-300 text-sm">Email: ordenamientoecologico.semadet@jalisco.gob.mx</p>
        </div>
      </div>
      <div className="bg-[#0c1322] py-4 text-center text-gray-400 text-sm">
        © 2025 Gobierno de Jalisco · Sistemas SEMADET · Todos los derechos reservados
      </div>
    </footer>
  );
}
